import React from 'react';
import styles from './TabsContent.module.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

export const MaxDescription = () => {

  return (
    <div className={styles.container}>
      <p className={styles.mainTitle}><span className={styles.highlight}>Max</span></p>
      <p className={styles.text}>
        Construcția cazanului este o singura unitate cilindrica montată și sudata, poziționată orizontal. Piesele sale principale sunt carcasa, camera de ardere,ansamblul tuburilor de jar și zona de curățare a cazanului. Caracteristica principala a acestui model este un economizator detașabil care are funcția de a mari eficienta cazanului.
      </p>
      Carcasa cazanului este confecționata din otel-carbon tratat și durabil și consta din cilindri coaxiali interni și externi. Partea de convecție este situată între cilindri sub forma tuburilor de jar. Este acoperit cu un strat de izolare termica, care se afla sub carcasa decorativă a cazanului.
      <p className={styles.text}>
        Temperatura este reglata de către un microprocesor sub forma unui bloc automatizat. El are rolul de stabilizare a temperaturii apei prin reducerea sau creșterea numărului de rotații a ventilatorului, cu rolul de alimentare cu aer a cazanului. Astfel, gazele eliberate în timpul procesului de ardere sunt eliminate, precum și sistemul  de încălzire este protejat de fierberea apei din sistemul schimbătorului de căldură.
      </p>
      <p className={styles.text}>
        Dispozitivul cazanului Altep Max este prevăzut cu conectarea pompei controlata de către controlerul cazanului. Cu toate astea microprocesorul este echipat cu funcția de pornire periodica  a pompei pentru a evita stagnarea acesteia la sfârșitul sezonului de încălzire.
      </p>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Parametri</th>
              <th>U.M.</th>
              <th colSpan="11">Altep Max</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Puterea nominală a cazanului</td>
              <td>kW</td>
              <td>95</td>
              <td>150</td>
              <td>200</td>
              <td>250</td>
              <td>300</td>
              <td>400</td>
              <td>500</td>
              <td>600</td>
              <td>700</td>
              <td>800</td>
            </tr>
            <tr>
              <td>Suprafața schimbătorului de căldură</td>
              <td>m²</td>
              <td>8,1</td>
              <td>12,4</td>
              <td>15,5</td>
              <td>21,8</td>
              <td>24,3</td>
              <td>25,8</td>
              <td>29,5</td>
              <td>36,0</td>
              <td>42,2</td>
              <td>47,5</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th colSpan="12">Mărimea camerei de ardere</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Adâncime</td>
              <td>mm</td>
              <td>940</td>
              <td>1100</td>
              <td>1290</td>
              <td>1410</td>
              <td>1410</td>
              <td>1410</td>
              <td>1550</td>
              <td>1820</td>
              <td>2280</td>
              <td>2280</td>
            </tr>
            <tr>
              <td>Volum</td>
              <td>dm³</td>
              <td>240</td>
              <td>280</td>
              <td>390</td>
              <td>500</td>
              <td>560</td>
              <td>650</td>
              <td>790</td>
              <td>920</td>
              <td>1100</td>
              <td>1750</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th colSpan="12">Mărimea gurii de alimentare</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Înălțime</td>
              <td>mm</td>
              <td>350</td>
              <td>350</td>
              <td>350</td>
              <td>400</td>
              <td>400</td>
              <td>400</td>
              <td>430</td>
              <td>430</td>
              <td>430</td>
              <td>430</td>
            </tr>
            <tr>
              <td>Lățime</td>
              <td>mm</td>
              <td>400</td>
              <td>400</td>
              <td>400</td>
              <td>500</td>
              <td>500</td>
              <td>500</td>
              <td>600</td>
              <td>600</td>
              <td>600</td>
              <td>600</td>
            </tr>
            <tr>
              <td>Volumul apei din cazan</td>
              <td>l</td>
              <td>460</td>
              <td>640</td>
              <td>680</td>
              <td>1160</td>
              <td>1320</td>
              <td>1320</td>
              <td>1470</td>
              <td>1800</td>
              <td>2250</td>
              <td>2400</td>
            </tr>
            <tr>
              <td>Greutate cazan, fără apă</td>
              <td>kg</td>
              <td>1200</td>
              <td>1580</td>
              <td>1690</td>
              <td>2200</td>
              <td>2450</td>
              <td>2650</td>
              <td>3000</td>
              <td>3600</td>
              <td>4200</td>
              <td>5000</td>
            </tr>
            <tr>
              <td>Putere tiraj gaze arse</td>
              <td>Pa</td>
              <td colSpan="10">10-80</td>
            </tr>
            <tr>
              <td>Temperatura gazelor la evacuare din cazan</td>
              <td>°C</td>
              <td colSpan="10">240-290</td>
            </tr>
            <tr>
              <td>Temperatura apei min recomandată</td>
              <td>°C</td>
              <td colSpan="10">58</td>
            </tr>
            <tr>
              <td>Temperatura apa max recomandată</td>
              <td>°C</td>
              <td colSpan="10">90</td>
            </tr>
            <tr>
              <td>Minim (maxim în lucru) presiune apă</td>
              <td>mPa</td>
              <td colSpan="10">0,30</td>
            </tr>
            <tr>
              <td>Presiunea de testare a apei, max</td>
              <td>mPa</td>
              <td colSpan="10">0,45</td>
            </tr>
            <tr>
              <td>Consum curent, max</td>
              <td>W</td>
              <td>170</td>
              <td>210</td>
              <td>210</td>
              <td>210</td>
              <td>320</td>
              <td>490</td>
              <td>810</td>
              <td>1110</td>
              <td>1110</td>
              <td>1110</td>
            </tr>
            <tr>
              <td>Diametru extern racord coș</td>
              <td>mm</td>
              <td>245</td>
              <td>298</td>
              <td>298</td>
              <td>348</td>
              <td>398</td>
              <td>398</td>
              <td>448</td>
              <td>498</td>
              <td>548</td>
              <td>548</td>
            </tr>
            <tr>
              <td>Diametrul rețelei de conexiune a apei</td>
              <td>mm</td>
              <td>65</td>
              <td>65</td>
              <td>65</td>
              <td>80</td>
              <td>80</td>
              <td>80</td>
              <td>100</td>
              <td>100</td>
              <td>100</td>
              <td>100</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th colSpan="12">Dimensiuni burlan</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Secțiunea transversală</td>
              <td>cm²</td>
              <td>483</td>
              <td>702</td>
              <td>702</td>
              <td>962</td>
              <td>1256</td>
              <td>1256</td>
              <td>1520</td>
              <td>1885</td>
              <td>2380</td>
              <td>2380</td>
            </tr>
            <tr>
              <td>Diametru intern</td>
              <td>mm</td>
              <td>250</td>
              <td>300</td>
              <td>300</td>
              <td>350</td>
              <td>400</td>
              <td>400</td>
              <td>450</td>
              <td>500</td>
              <td>550</td>
              <td>550</td>
            </tr>
            <tr>
              <td>Înălțime (min permisă)</td>
              <td>m</td>
              <td>9</td>
              <td>10</td>
              <td>14</td>
              <td>14</td>
              <td>11</td>
              <td>15</td>
              <td>16</td>
              <td>16</td>
              <td>16</td>
              <td>17</td>
            </tr>
            <tr>
              <td>Diametrul țevii de sub siguranțele supapei</td>
              <td>mm</td>
              <td>40</td>
              <td>40</td>
              <td>40</td>
              <td>50</td>
              <td>50</td>
              <td>2×50</td>
              <td>2×50</td>
              <td>2×50</td>
              <td>2×50</td>
              <td>2×50</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export const MaxDimensions = () => {
  const data = [
    { param: "B", unit: "mm", values: [1000, 1000, 1000, 1230, 1290, 1290, 1400, 1410, 1410, 1550] },
    { param: "H", unit: "mm", values: [1670, 1860, 1860, 2020, 2130, 2230, 2250, 2280, 2280, 2520] },
    { param: "H1", unit: "mm", values: [1540, 1740, 1740, 1900, 2000, 2110, 2130, 2160, 2160, 2340] },
    { param: "H2", unit: "mm", values: [1325, 1485, 1487, 1617, 1719, 1786, 1855, 1912, 1930, 2125] },
    { param: "H3", unit: "mm", values: [320, 320, 320, 375, 385, 385, 380, 385, 385, 385] },
    { param: "L", unit: "mm", values: [2110, 2340, 2530, 2670, 2670, 2670, 2900, 3250, 3780, 3780] },
    { param: "L1", unit: "mm", values: [1310, 1470, 1670, 1780, 1780, 1780, 1940, 2210, 2670, 2670] }
  ]

  const headers = ["Dimensiuni", "U.M.", "95 kW", "150 kW", "200 kW", "250 kW", "300 kW", "400 kW", "500 kW", "600 kW", "700 kW", "800 kW"]

  return (
    <div className={styles.dimensionsContainer}>
      <div className={styles.imageContainer}>
        <img src="/Dimensions/MaxSchema.png" alt="Descriptive Alt Text" className={styles.centeredImage} />
      </div>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              {headers.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td>{row.param}</td>
                <td>{row.unit}</td>
                {row.values.map((value, valueIndex) => (
                  <td key={valueIndex}>{value}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};